import { Component, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../../core/service/common-service/common.service";
import { MatDialog, MatSort, MatPaginator, MatTableDataSource, MatTabChangeEvent} from "@angular/material";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { element } from 'protractor';
import { CallParams } from "src/app/model/call-params.model";
import { DialogService } from "src/app/dialog.service";

@Component({
  selector: "app-soft-customer360",
  templateUrl: "./soft-customer360.component.html",
  styleUrls: ["./soft-customer360.component.scss"],
})
export class SoftCustomer360Component implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("CallLogsPaginator", { static: false })
  callLogsPaginator: MatPaginator;
  @ViewChild("CallLogsSort", { static: true }) callLogsSort: MatSort;
  @ViewChild("RemarksPaginator", { static: true })
  remarksPaginator: MatPaginator;
  @ViewChild("RemarksSort", { static: true }) remarksSort: MatSort;
  @ViewChild("ServiceHistoryPaginator", { static: true })
  serviceHistoryPaginator: MatPaginator;
  @ViewChild("ServiceHistorySort", { static: true })
  serviceHistorySort: MatSort;
  @ViewChild("ContractSort", { static: true }) contractSort: MatSort;
  @ViewChild("ContractPaginator", { static: true }) contractPaginator: MatPaginator;

  cus360: any;
  vehicleDetails: any = {};
  amcDetails: any = {};
  lastServiceDetails: any = {};
  serviceDetails: any = {};
  faultDetails: any = [];
  callVisible: boolean;
  spinner: boolean;
  vinNoList: string[] = [];
  vehicleInfoList: any[] = [];
  vehicleTypeCallInfo: any;
  vehicleServiceAndStausInfo: any;
  dataSource: any;
  selectedNumber: any;
  updatedNumber: any;
  contactInfoOwner: any[] = [];
  contactInfoFleet: any[] = [];
  contactInfoDriver: any[] = [];
  updatedNumberType: string;
  secondaryNo: string;
  unableEdit: any = {};
  unableCall: boolean = false;
  workShops = <any>[];
  selectedWorkShop: string;
  audioSource: any = {};
  selectedVehicle: string;
  HideServiceHistory: boolean = true;
  historyToggleStatus: boolean = false;
  showCallDailog: boolean = false;
  showRecordingDailog: boolean = false;
  showPlayBtn: boolean = true;
  paused: boolean = false;
  ownerSelected: boolean = true;
  fleetSelected: boolean = false;
  driverSelected: boolean = false;
  errorShow: any = {};
  customerID: string;
  userId: string;
  chassisNo: string;
  recentNumber: string;
  bookingCount: any;
  followupCount: any;
  customerData: any;
  custCallSeqResponse: any;
  callTypeSq: any;
  selectedVin: any;
  questionType: any;
  amcQuestions: any = [];
  amcReQuestions: any = [];
  ewQuestions: any = [];
  irQuestions: any = [];
  AMCQuestionForm: FormGroup;
  amcRQuestionForm : FormGroup;
  ewQuestionForm: FormGroup;
  irQuestionForm: FormGroup;
  userRolesId: string;
  submitted: boolean = false;
  amcQuestionInfo = [];
  amcRQuestionInfo = [];
  ewQuestionInfo = [];
  irQuestionInfo = [];
  amcNewOffering: string;
  amcRenewal: string;
  extendedWarranty: string;
  insuranceRenewal: string;
  formSubmitted: boolean = false;
  amctextFlag: boolean = false;
  amcdropdownFlag: boolean = false;
  amcdateFlag: boolean = false;
  amcradioFlag: boolean = false;
  amcRetextFlag: boolean = false;
  amcRedropdownFlag: boolean = false;
  amcRedateFlag: boolean = false;
  amcReradioFlag: boolean = false;
  irtextFlag: boolean = false;
  irdropdownFlag: boolean = false;
  irdateFlag: boolean = false;
  irradioFlag: boolean = false;
  ewtextFlag: boolean = false;
  ewdropdownFlag: boolean = false;
  ewdateFlag: boolean = false;
  ewradioFlag: boolean = false;
  chassis: string;
  showField: boolean = true;
  amcSelectedQuestionStatus: any[] = [];
  amcReSelectedQuestionStatus: any[] = [];
  irSelectedQuestionStatus: any[] = [];
  ewSelectedQuestionStatus: any[] = [];
  amcSelectedQuestionCurrentStatus: any[] = [];
  amcReSelectedQuestionCurrentStatus: any[] = [];
  irSelectedQuestionCurrentStatus: any[] = [];
  ewSelectedQuestionCurrentStatus: any[] = [];
  selectedQuestionValue: any;
  amcInProgress: string = '';
  amcReInProgress: string = '';
  irInProgress: string = '';
  ewInProgress: string = '';
  inProgressQuestionId: string;
  amcAutofilledResponse: any[] = [];
  amcReAutofilledResponse: any[] = [];
  ewAutofilledResponse: any[] = [];
  irAutofilledResponse: any[] = [];
  availableOfferings: any[] = [];
  today: Date = new Date();
  dropdownData: any = {
    "2": ["CONSTRUCTION", "CONTAINER", "MINING- ORE TRANSPORTATION", "REFER VAN", "AUTO PARTS", "AUTO CARRIER-2 WHEELER & CAR CARRIER",
    "POULTRY", "LPG CYLINDER", "COURIER/PARCEL", "PACKERS & MOVERS", "CONSTRUCTION MATERIAL", "CEMENT", "STEEL", "FOOD GRAINS", "GARMENTS/TEXTILE",
    "TANKER", "BULKER", "RMC", "PERISHABLE GOODS/MEDICINES/ MEAT/FISH", "MINING- OVERBURDEN", "MINING- ORE TRANSPORTATION", "LOGISTICS", "E-COMMERCE",
    "FUEL DISPENSER", "WASTE MANAGEMENT", "WHITE GOODS", "Fire safety", "CNG Cascade",],
    "6": ["LC Smart", "LC Smart+", "LCC Smart", "LCC Smart XL", "LCP", "LCP Smart", "LCP +"],
    "7": ["CONSTRUCTION", "CONTAINER", "MINING- ORE TRANSPORTATION", "REFER VAN", "AUTO PARTS", "AUTO CARRIER-2 WHEELER & CAR CARRIER",
      "POULTRY", "LPG CYLINDER", "COURIER/PARCEL", "PACKERS & MOVERS", "CONSTRUCTION MATERIAL", "CEMENT", "STEEL", "FOOD GRAINS", "GARMENTS/TEXTILE",
      "TANKER", "BULKER", "RMC", "PERISHABLE GOODS/MEDICINES/ MEAT/FISH", "MINING- OVERBURDEN", "MINING- ORE TRANSPORTATION", "LOGISTICS", "E-COMMERCE",
      "FUEL DISPENSER", "WASTE MANAGEMENT", "WHITE GOODS", "Fire safety", "CNG Cascade",],
    "35": ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    "11": ["Monthly", "Quarterly", "Half Yearly", "Yearly", "One-time"],
    "12": ["Cheques", "NEFT", "Online Payment"],
    "14": ["Lead Status", "Current lead status"],
    "14-1": ["Hot", "Warm", "Cold"],
    "14-2": ["In process", "Loss", "Deal Closed"],
    "14-2-1": ["Requirement gathering", "price negotiation", "Quotation given"],
    "33": ["Cheques", "NEFT", "Online Payment"],
    "36": ["Lead Status", "Current lead status"],
    "36-1": ["Hot", "Warm", "Cold"],
    "36-2": ["In process", "Loss", "Deal Closed"],
    "36-2-1": ["Requirement gathering", "price negotiation", "Quotation given"],
    "26": ["Cheques", "NEFT", "Online Payment"],
    "37": ["Lead Status", "Current lead status"],
    "37-1": ["Hot", "Warm", "Cold"],
    "37-2": ["In process", "Loss", "Deal Closed"],
    "37-2-1": ["Requirement gathering", "price negotiation", "Quotation given"]
  }

  //service history table columns
  displayedColumns: string[] = [
    "jcNo",
    "servNo",
    "dealerLoc",
    "jbcardDate",
    "mileage",
    "failureDate",
    "billDate",
    "insdate",
    "mechanic",
    "serviceAdv",
    "serviceAdvNo",
  ];

  //call log table columns
  displayedCallColumns: string[] = [
    "number",
    "callDate",
    "startTime",
    "duration",
    "recording",
  ];

  //call log table columns
  displayedContractColumns: string[] = [
    "startDate",
    "endDate",
    "contractName",
    "contractNumber",
    "productName",
  ];

  //call log table columns
  displayedRemarksColumns: string[] = ["remark", "remarkDate", "remarkTime"];

  displayedFaultColumns: string[] = [
    "faultCaseId",
    "rulesDesc",
    "faultListDate",
    "faultFertCode",
    "faultServiceDueDate",
    "faultBookingDate",
  ];

  dataSource1: any[];
  expandedElement: any[] = [];
  rows: any = [];

  callLists: any;
  callCount: number = 0;
  contractCount: number = 0;
  contractList: any;
  remarksDetails: any;
  historyDetails: any;
  remarksCount: number = 0;
  historyCount: number = 0;
  private audio: HTMLMediaElement;

  selectedTab: any;
  cdmTrailCheckOwner:boolean=false;
  cdmTrailCheckfleet:boolean=false;
  cdmTrailCheckdriver:boolean=false;
  secondTrailCall:boolean=false;
  calledNo: string;
  cusType: string;
  customerName: any;
  custNameForSave: any;

  constructor(
    private dialogService: DialogService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private commonService: CommonService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.unableEdit["O"] = {};
    this.unableEdit["F"] = {};
    this.unableEdit["D"] = {};
  }

  ngOnInit() {
    this.callVisible = true;
    this.chassisNo = localStorage.getItem("chassisNo");
    this.userId = localStorage.getItem("userId");
    this.customerID = localStorage.getItem("customerId");
    this.workShops = JSON.parse(localStorage.getItem("workshops"));
    this.customerData = JSON.parse(localStorage.getItem("customerData")) || {};
    this.userRolesId = JSON.parse(localStorage.getItem("userInfo"))[0].roleId;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))[0];
    this.selectedWorkShop =
      this.workShops && this.workShops.length
        ? this.workShops[0].workshopCode
        : "";
        this.callTypeSq = this.customerData.callTypeSq;

    if (localStorage.getItem("userId") == null || localStorage.getItem("userId") == undefined) {
      this.router.navigate(["login"]);
    }

    this.getCustomer360();
    this.getCallDetails();
    this.getContactdetail();
    //this.getAmcFetchQuestions();
  
    
  }

  /**
   * Name: getCallRecording
   * purpose: To get call recording and play
   */
  recordingUrl:string = ''
  getCallRecording(bucketName: string, fileName: string, id: string, source: string ,element:any): void {
console.log(element);

    this.spinner = true;
    this.onRecordingClose();
    
    if (element.recordingUrl) {
      this.recordingUrl = element.recordingUrl;
    }else{
      this.recordingUrl = '';
    }
    
    this.commonService.downloadAudio(bucketName, fileName, source).subscribe(
      (res) => {
        this.spinner = false;
        var binary = res["body"];
        var blob = new Blob([binary], { type: "audio/mp4" });
        this.audioSource.id = id;
        this.audioSource.url = URL.createObjectURL(blob);
        if (this.audioSource.url) {
          this.playRecording();
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }
  /**
   * Name: playRecording
   * purpose: To play recoding
   */
  playRecording(): void {
    this.showPlayBtn = false;
    this.showRecordingDailog = true;
  }

  /**
   * Name: onRecordingClose
   * purpose: To close Recording dailog
   */
  onRecordingClose() {
    this.showPlayBtn = true;
    this.showRecordingDailog = false;
  }

  /**
   * Name: getContactdetail
   * purpose: To get customer Contact detail
   */
  getContactdetail(): void {
    this.spinner = true;
    this.commonService.amcContactdetail(this.customerID).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.contactInfoOwner = res["responseData"].filter(
            (contact) => contact.flag == "O"
          );
          this.contactInfoFleet = res["responseData"].filter(
            (contact) => contact.flag == "F"
          );
          this.contactInfoDriver = res["responseData"].filter(
            (contact) => contact.flag == "D"
          );
          this.selectedNumber = this.contactInfoOwner[0].contactNo;
          this.unableEdit["O"][0] = true;
          this.unableEdit["O"][1] = false;
          this.unableEdit["D"][0] = true;
          this.unableEdit["D"][1] = false;
          this.updatedNumberType = "Primary";
          this.unableCall = true;
          this.spinner = false;
        } else {
          this.spinner = false;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      },
      ()=>{
        this.updateActiveContactNo();
      }
    );
  }

  getCdmData(){
    let temp:any;
    this.selectedTab=this.selectedTab?this.selectedTab:0;

    let ab={id: 2, name: "SHAH SAMIRKUMAR KANAIYALAL", contactNo: "111111111", regNumber: null, flag: "O"}
    // this.contactInfoOwner.push(ab);
    let data={
      "customerId": this.customerID,
      "vin": "",
      "phoneNo": "",
      "startDate": "",
      "endDate": "",
      "date": "",
      "customerName": "",
      "type": "T",
      "flag":this.selectedTab==0?'C':this.selectedTab==1?'F':this.selectedTab==2?'D':'C'
       };
    this.commonService.fetchCdmData(data).subscribe((resp)=>{
      if(resp['responseCode']==0){
        temp=resp["responseData"].filter(contact => contact.contactNo = contact.phoneNo);
        temp.forEach((trail)=>{
          if(this.selectedTab==0){
          this.contactInfoOwner.push(trail)
          this.cdmTrailCheckOwner=true
          }else if(this.selectedTab==1){
            this.contactInfoFleet.push(trail)
            this.cdmTrailCheckfleet=true
          }else if(this.selectedTab==2){
            this.contactInfoDriver.push(trail)
            this.cdmTrailCheckdriver=true
          }
        })
        this.trailLogCheck();
      }else{
        this.toastr.error(resp['message'], "Error");
      }

    }, error => {
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
    // this.contactInfoOwner.push(temp[0]);

  }

  trailLogCheck(){
    if(this.selectedTab==0){
      this.secondTrailCall=this.cdmTrailCheckOwner
      // return this.cdmTrailCheckOwner
    }else if (this.selectedTab==1){
      this.secondTrailCall=this.cdmTrailCheckfleet
      // return this.cdmTrailCheckfleet
    }else if(this.selectedTab==2){
      this.secondTrailCall=this.cdmTrailCheckdriver
      // return this.cdmTrailCheckdriver
    }else{
      this.secondTrailCall=false
    }
  }

  /**
   * Name: checkCallStatus
   * purpose: To set contect type selection
   * @param {any} type - type of number
   */
  checkCallStatus(type: any): void {
    this.onTabChange(type);
    this.selectedTab=type && type.index;
    if (type && type.index == 0) {
      this.ownerSelected = true;
      this.fleetSelected = false;
      this.driverSelected = false;
      if (this.contactInfoOwner.length) {
        this.unableCall = true;
        this.contactInfoOwner.forEach((element, i) => {
          if (this.unableEdit["O"][i] != undefined && this.unableEdit["O"][i]) {
            this.selectedNumber = element.contactNo;
          }
        });
      } else {
        this.unableCall = false;
      }
    }

    if (type && type.index == 1) {
      this.ownerSelected = false;
      this.fleetSelected = true;
      this.driverSelected = false;
      if (this.contactInfoFleet.length) {
        this.unableCall = true;
        let numberSelected = false;
        this.contactInfoFleet.forEach((element, i) => {
          if (this.unableEdit["F"][i] != undefined && this.unableEdit["F"][i]) {
            this.selectedNumber = element.contactNo;
            numberSelected = true;
          }
        });
        if (!numberSelected) {
          this.selectedNumber = this.contactInfoFleet[0].contactNo;
          this.unableEdit["F"][0] = true;
        }
      } else {
        this.unableCall = false;
      }
    }

    if (type && type.index == 2) {
      this.ownerSelected = false;
      this.fleetSelected = false;
      this.driverSelected = true;
      if (this.contactInfoDriver.length) {
        this.unableCall = true;
        let numberSelected = false;
        this.contactInfoDriver.forEach((element, i) => {
          if (this.unableEdit["D"][i] != undefined && this.unableEdit["D"][i]) {
            this.selectedNumber = element.contactNo;
            numberSelected = true;
          }
        });
        if (!numberSelected) {
          this.selectedNumber = this.contactInfoDriver[0].contactNo;
          this.unableEdit["D"][0] = true;
        }
      } else {
        this.unableCall = false;
      }

    }
    this.trailLogCheck();
  }

  getCustomerName(type) {
    if(type=='C'){
      this.contactInfoOwner.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
          // return this.custNameForSave
        }
      });
    }else if(type=='F'){
      this.contactInfoFleet.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
          // return this.custNameForSave
        }
      });
    }
    else if(type=='D'){
      this.contactInfoDriver.forEach((element)=>{
        if(element.contactNo==this.selectedNumber){
          this.custNameForSave=element.name
          // return this.custNameForSave
        }
      });
    }
    else{
      this.custNameForSave= this.cus360["CUSTOMER_INFO"].custName
      // return this.cus360["CUSTOMER_INFO"].custName
    }
  }

  /**
   * Name: callUser
   * purpose: To call user
   */
  private callUser(): void {
    this.showRecordingDailog = false;
    this.spinner = true;
    let callNumber = "+91" + this.selectedNumber;
    let type = this.ownerSelected ? "C" : this.fleetSelected ? "F" : "D";
    this.calledNo=this.selectedNumber;
    this.cusType=type;
    this.getCustomerName(this.cusType);
    this.customerName=this.custNameForSave
    
    this.commonService.callCustomer(this.userId, this.customerID, callNumber, type, '').subscribe((res) => {
      if (res["responseCode"] == 0) {
        this.showCallDailog = true;
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res["message"], "Error");
      }
    },(err) => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
    
    if (localStorage.getItem('countryCode')=='IND91') {
      this.callingToUser();
     }else{
      localStorage.setItem("exotel_URI",'')
     }
 
  }

  /**
   * Name: onClose
   * purpose: To close call dailog
   */
  onClose() {
    this.showCallDailog = false;
    this.getContactdetail();
  }

  /**
   * Name: updateNumber
   * @param {boolean} addNumber - type of number
   * purpose: To set customer number
   */
  updateNumber(addNumber: boolean): void {
    if (
      (this.updatedNumber && this.updatedNumber.length == 10) ||
      (addNumber && this.secondaryNo && this.secondaryNo.length == 10)
    ) {
      this.spinner = true;
      let oldNumber = this.selectedNumber;
      let newNumber = this.updatedNumber;
      if (addNumber) {
        oldNumber = this.secondaryNo;
        newNumber = this.secondaryNo;
        this.updatedNumberType = "Secondary";
      }
      this.commonService
        .amcUpdateNumber(
          newNumber,
          oldNumber,
          this.updatedNumberType,
          this.customerID,
          this.userId
        )
        .subscribe(
          (res) => {
            if (res["responseCode"] == 0) {
              this.spinner = false;
              this.selectedNumber = this.updatedNumber;
              this.toastr.success("New number is saved.", "Success");
              this.getContactdetail();
            } else {
              this.spinner = false;
              this.toastr.error(res["message"], "Error");
            }
          },
          (err) => {
            this.spinner = false;
            this.toastr.error(
              "Something went wrong, Please try again.",
              "Error"
            );
          }
        );
    }
  }

  /**
   * Name: onNumberChange
   * purpose: To get new selected number
   */
  onNumberChange(
    number: any,
    editNumber: boolean,
    index: any,
    type: string
  ): void {
    
    if (type == "D" && editNumber && number.currentTarget.value.length == 10) {
      this.updatedNumber = number.currentTarget.value;
      this.updatedNumberType = "D";
      this.errorShow[index] = false;
    } else if (editNumber && number.currentTarget.value.length == 10) {
      this.updatedNumber = number.currentTarget.value;
      this.updatedNumberType = index == 0 ? "Y" : "N";
      this.errorShow[index] = false;
    } else if (editNumber && number.currentTarget.value.length !== 10) {
      this.errorShow[index] = true;
    } else {
      this.selectedNumber = number.value;
      this.updatedNumber = number.value;
      this.updatedNumberType = index == 0 ? "Y" : "N";
      if (type == "O") {
        this.contactInfoOwner.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      } else if (type == "F") {
        this.contactInfoFleet.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      } else if (type == "D") {
        this.contactInfoDriver.forEach((element, i) => {
          if (i == index) {
            this.unableEdit[type][i] = true;
          } else {
            this.unableEdit[type][i] = false;
          }
        });
      }
    }
  }

  /**
   * Name: sendWorkshopMsg
   * purpose: To send workshop addess SMS
   */
  sendWorkshopMsg(): void {
    this.spinner = true;
    let data = {
      contactNo: this.selectedNumber,
      custName: this.cus360["CUSTOMER_INFO"].custName,
    };
    this.workShops.forEach((workshop) => {
      if (workshop.workshopCode == this.selectedWorkShop) {
        data["wSAddress"] = workshop.workshopAddress || "";
        data["wSManager"] = workshop.contactNo || "";
        data["wSName"] = workshop.workshopName || "";
      }
    });
    this.commonService.sendLocationSMS(data).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: getCustomer360
   * purpose: To get customer data
   */
  getCustomer360(): void {
    this.spinner = true;
    //let dealerCode = this.customerData.dealerCode || "";
    let callTypeSeq = this.customerData.callTypeSq || "";

    this.commonService.getamccustomerdata(this.userId, this.customerID, this.selectedWorkShop, callTypeSeq, this.userRolesId).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.cus360 = res["responseData"];
          if (
            this.cus360["VECHILE_INFO"] &&
            this.cus360["VECHILE_INFO"].length &&
            this.cus360["VECHILE_INFO"][0].vin6Bits
          ) {
            //this.selectedVehicle = this.cus360["VECHILE_INFO"][0].chassisNo;
            this.selectedVehicle = this.cus360["VECHILE_INFO"][0].vin6Bits;
            this.cus360["VECHILE_INFO"].forEach((element) => {
              this.vinNoList.push(element.chassisNo);
              this.vehicleInfoList.push(element);
            });
            this.subTabDefault(this.selectedVehicle);
          } else {
            this.vehicleDetails = {};
          }
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: getHistory
   * purpose: To get service history
   */
  getHistory(showHistory: boolean): void {
    if (showHistory) {
      this.spinner = true;
      this.commonService.history(this.selectedVin).subscribe(
        res => {
          if (res["responseCode"] == 0) {
            this.HideServiceHistory = false;
            this.dataSource1 = res["responseData"];
            this.historyDetails= new MatTableDataSource(this.dataSource1);
            this.sort.direction = '';
            this.historyDetails.sort = this.serviceHistorySort;
            this.historyDetails.paginator = this.serviceHistoryPaginator;
            this.historyCount = this.dataSource1.length;
            this.spinner = false;
          } else {
            this.toastr.info(res["message"]);
            this.historyDetails = [];
            this.spinner = false;
            this.historyToggleStatus = false;
          }
        }, err => {
          this.spinner = false;
          this.historyToggleStatus = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    } else {
      this.HideServiceHistory = true;
    }
  }

  /**
   * Name: getCallList
   * purpose: To get customer call data
   */
  getCallDetails(): void {
    this.spinner = true;
    this.commonService.callDetails(this.userId, this.customerID,'AMC').subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
         
          this.callLists = new MatTableDataSource(res["responseData"]);
          this.recentNumber =
            res["responseData"].length && res["responseData"][0].custNo
              ? res["responseData"][0].custNo.split("+91")[1]
              : "";
          this.sort.direction = "";
          this.callLists.sort = this.callLogsSort;
          this.callLists.paginator = this.callLogsPaginator;
          this.callCount = res["responseData"].length;
        } else {
          this.spinner = false;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: subTabDefault
   * purpose: To set vehicle details as selected
   */
  subTabDefault(selectedVehicle: string): void {
    this.vehicleDetails = this.cus360["VECHILE_INFO"].filter((vehicle) => vehicle.vin6Bits == selectedVehicle)[0];
    this.selectedVin = this.vehicleDetails.chassisNo;
    this.fetchCustCallSeq(this.vehicleDetails.chassisNo);

    //set the vehicle call Info
    if (this.cus360["SERVICE_INFO"] && Object.keys(this.cus360["SERVICE_INFO"]).length && this.cus360["SERVICE_INFO"][selectedVehicle]) {
      this.serviceDetails = this.cus360["SERVICE_INFO"][selectedVehicle];

      localStorage.setItem("serviceInfo",JSON.stringify(this.cus360["SERVICE_INFO"]));

      //set the vehicle call Info
      this.vehicleServiceAndStausInfo = this.serviceDetails.campaignId ? this.serviceDetails.serviceType : this.serviceDetails.serviceType + ", " + this.serviceDetails.callStatus;
      this.vehicleTypeCallInfo = this.serviceDetails.callType;
    } else {
      this.serviceDetails = {};
    }

    if (this.cus360["LAST_SERVICE_INFO"] && Object.keys(this.cus360["LAST_SERVICE_INFO"]).length && this.cus360["LAST_SERVICE_INFO"][selectedVehicle]) {
      this.lastServiceDetails = this.cus360["LAST_SERVICE_INFO"][selectedVehicle];
      localStorage.setItem("milage", this.lastServiceDetails.milage);
      this.lastServiceDetails.invoiceDate = this.datePipe.transform(
        this.lastServiceDetails.invoiceDate,
        "yyyy-MM-dd"
      );
    } else {
      this.lastServiceDetails = {};
    }

    if (this.cus360["Remark_Info"] && Object.keys(this.cus360["Remark_Info"]).length && this.cus360["Remark_Info"][selectedVehicle]) {
      let remarks = this.cus360["Remark_Info"][selectedVehicle];
      // remarks.forEach(element => {
      //   let date = element.remarkTime;
      //   let d = new Date(date);
      //   element.remarkTime = d;
      //   element.remarkDate = this.datePipe.transform(element.remarkDate, "yyyy-MM-dd");
      // });
      this.remarksDetails = new MatTableDataSource(remarks);
      this.sort.direction = '';
      this.remarksDetails.sort = this.remarksSort;
      this.remarksDetails.paginator = this.remarksPaginator;
      this.remarksCount = remarks.length;
    } else {
      this.remarksDetails = [];
    }

    if (this.cus360["CONTRACT_DETAIL"] && Object.keys(this.cus360["CONTRACT_DETAIL"]).length && this.cus360["CONTRACT_DETAIL"][selectedVehicle]) {
      let contracts = this.cus360["CONTRACT_DETAIL"][selectedVehicle];
      this.contractList = new MatTableDataSource(contracts);
      this.sort.direction = "";
      this.contractList.sort = this.contractSort;
      this.contractList.paginator = this.contractPaginator;
      this.contractCount = contracts.length;
    } else {
      this.contractList = [];
    }
  }

  /**
   * Name: fetchCustCallSeq
   * purpose: To get customer call data
   */
  fetchCustCallSeq(vin : string): void {
    this.spinner = true;
    this.commonService.fetchCustCallSeq(this.customerID, vin, this.userRolesId, this.userId).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.custCallSeqResponse = res["responseData"];
          this.amcNewOffering = this.custCallSeqResponse.amcNewOffering;
          this.amcRenewal = this.custCallSeqResponse.amcRenewal;
          this.extendedWarranty = this.custCallSeqResponse.extendedWarranty;
          this.insuranceRenewal = this.custCallSeqResponse.insuranceRenewal;
          this.availableOfferings = this.custCallSeqResponse.availableOfferings;
          this.amcAutofilledResponse = this.custCallSeqResponse.amcAutofillQuestion;
          this.amcReAutofilledResponse = this.custCallSeqResponse.amcReAutofillQuestion;
          this.ewAutofilledResponse = this.custCallSeqResponse.ewAutofillQuestion;
          this.irAutofilledResponse = this.custCallSeqResponse.irAutofillQuestion;
          if(this.amcNewOffering == "YES"){
            this.getAmcFetchQuestions("1")
          }
          if(this.amcRenewal == "YES"){
            this.getAmcFetchQuestions("2")
          }
          if(this.extendedWarranty == "YES"){
            this.getAmcFetchQuestions("4")
          }
          if(this.insuranceRenewal == "YES"){
            this.getAmcFetchQuestions("3")
          }
        } else {
          this.spinner = false;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: getAutoFilledQuestions
   * purpose: To get Auto Filled Questions
   */
  getAutoFilledQuestions(category: string, vin: string): void {
    this.spinner = true;
    this.commonService.getAutoFilledQuestions(this.customerID, category, this.userId, vin).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          if(category == "1") {
            this.amcAutofilledResponse = res["responseData"];
          }
          if(category == "2") {
            this.amcReAutofilledResponse = res["responseData"];
          }
          if(category == "3") {
            this.irAutofilledResponse = res["responseData"];
          }
          if(category == "4") {
            this.ewAutofilledResponse = res["responseData"];
          }
        } else {
          this.spinner = false;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: getAmcFetchQuestions
   * purpose: To get Amc Questions
   */
  getAmcFetchQuestions(val : string): void {
    this.spinner = true;
    this.commonService.getAmcFetchQuestions(this.userId, val, this.userRolesId).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          let groups = [];
          if(val == "1") {
            this.amcQuestions = [];
            this.amcQuestionInfo = [];
            res["responseData"].forEach((element) => {
              let questionGroup = [];
              let groupexist = groups.filter(
                (group) => group == element.parentId
              );
              if (Number(element.parentId) > 0 && groupexist.length == 0) {
                questionGroup = res["responseData"].filter(
                  (question) => question.parentId == element.parentId
                );
                this.amcQuestions.push(questionGroup);
                groups.push(element.parentId);
              } else if (groupexist.length == 0) {
                this.amcQuestions.push(element);
              }
            });
            this.createAmcQuestionForm(this.amcQuestions);
          }
          if(val == "2") {
            this.amcReQuestions = [];
            this.amcRQuestionInfo = [];
            res["responseData"].forEach((element) => {
              let questionGroup = [];
              let groupexist = groups.filter(
                (group) => group == element.parentId
              );
              if (Number(element.parentId) > 0 && groupexist.length == 0) {
                questionGroup = res["responseData"].filter(
                  (question) => question.parentId == element.parentId
                );
                this.amcReQuestions.push(questionGroup);
                groups.push(element.parentId);
              } else if (groupexist.length == 0) {
                this.amcReQuestions.push(element);
              }
            });
            this.createAMCRQuestionForm(this.amcReQuestions);
          }
          if(val == "4") {
            this.ewQuestions = [];
            this.ewQuestionInfo = [];
            res["responseData"].forEach((element) => {
              let questionGroup = [];
              let groupexist = groups.filter(
                (group) => group == element.parentId
              );
              if (Number(element.parentId) > 0 && groupexist.length == 0) {
                questionGroup = res["responseData"].filter(
                  (question) => question.parentId == element.parentId
                );
                this.ewQuestions.push(questionGroup);
                groups.push(element.parentId);
              } else if (groupexist.length == 0) {
                this.ewQuestions.push(element);
              }
            });
            this.createEWQuestionForm(this.ewQuestions);
          }
          if(val == "3") {
            this.irQuestions = [];
            this.irQuestionInfo = [];
            res["responseData"].forEach((element) => {
              let questionGroup = [];
              let groupexist = groups.filter(
                (group) => group == element.parentId
              );
              if (Number(element.parentId) > 0 && groupexist.length == 0) {
                questionGroup = res["responseData"].filter(
                  (question) => question.parentId == element.parentId
                );
                this.irQuestions.push(questionGroup);
                groups.push(element.parentId);
              } else if (groupexist.length == 0) {
                this.irQuestions.push(element);
              }
            });
            this.createIRQuestionForm(this.irQuestions);
          }
          //this.createQuestionForm(this.questions);
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  /**
   * Name: createQuestionForm
   * purpose: To create question form
   */
  createAmcQuestionForm(data: any) {
    this.submitted = false;
    const formDataObj = {};
    let questionIdAdded = [];
    for (const prop of data) {
      let response = '';
      let remark = '';
      this.amcAutofilledResponse.forEach((element) => {
        if(element.questionDesc == prop.questionDesc) {
          response = element.questionResponse;
          remark = element.remarks;
        }
      })
      if (!prop.length) {
        this.showField = true;
        if(prop.questionDesc == 'In process' || prop.questionDesc == 'Loss'
        || prop.questionDesc == 'Deal Closed') {
          this.showField = false;
        }
        let questionExist;
        if (prop.radioButtonType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "radio"] = new FormControl(response);
          this.amcQuestionInfo.push({
            label: prop.questionId + "radio",
            type: "RadioButton",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            parentId: prop.parentId,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dropdownType == "Yes") {
        questionExist = questionIdAdded.filter(
          (group) => group == prop.questionId
        );
        formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
        this.amcQuestionInfo.push({
          label: prop.questionId + "dropdown",
          type: "Dropdown",
          desc: prop.questionDesc,
          id: prop.questionSequence,
          questionId: prop.questionId,
          showDesc: questionExist.length ? false : true,
          subQuestion: true,
          parentId: prop.parentId,
          data: this.dropdownData[prop.questionId],
          showField: this.showField
        });
        questionIdAdded.push(prop.questionId);
        }

        if (prop.remarksType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "text"] = new FormControl(remark);
          this.amcQuestionInfo.push({
            label: prop.questionId + "text",
            type: "Text",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            parentId: prop.parentId,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dateType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "date"] = new FormControl(response);
          this.amcQuestionInfo.push({
            label: prop.questionId + "date",
            type: "Date",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            parentId: prop.parentId,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.questionId == "14") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
          this.amcQuestionInfo.push({
            label: prop.questionId + "dropdown",
            type: "Dropdown",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: true,
            parentId: prop.parentId,
            data: this.dropdownData[prop.questionId],
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
          }
      }
    }
    this.AMCQuestionForm = new FormGroup(formDataObj);
  }

  /**
   * Name: createQuestionForm
   * purpose: To create question form
   */
  createAMCRQuestionForm(data: any) {
    this.submitted = false;
    const formDataObj = {};
    let questionIdAdded = [];
    for (const prop of data) {
      let response = '';
      let remark = '';
      this.amcReAutofilledResponse.forEach((element) => {
        if(element.questionDesc == prop.questionDesc) {
          response = element.questionResponse;
          remark = element.remarks;
        }
      })
      if (!prop.length) {
        this.showField = true;
        if(prop.questionDesc == 'In process' || prop.questionDesc == 'Loss'
        || prop.questionDesc == 'Deal Closed') {
          this.showField = false;
        }
        let questionExist;
        if (prop.radioButtonType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "radio"] = new FormControl(response);
          this.amcRQuestionInfo.push({
            label: prop.questionId + "radio",
            type: "RadioButton",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dropdownType == "Yes") {
        questionExist = questionIdAdded.filter(
          (group) => group == prop.questionId
        );
        formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
        this.amcRQuestionInfo.push({
          label: prop.questionId + "dropdown",
          type: "Dropdown",
          desc: prop.questionDesc,
          id: prop.questionSequence,
          questionId: prop.questionId,
          showDesc: questionExist.length ? false : true,
          subQuestion: true,
          parentId: prop.parentId,
          data: this.dropdownData[prop.questionId],
          showField: this.showField
        });
        questionIdAdded.push(prop.questionId);
        }

        if (prop.remarksType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "text"] = new FormControl(remark);
          this.amcRQuestionInfo.push({
            label: prop.questionId + "text",
            type: "Text",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dateType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "date"] = new FormControl(response);
          this.amcRQuestionInfo.push({
            label: prop.questionId + "date",
            type: "Date",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.questionId == "14") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
          this.amcRQuestionInfo.push({
            label: prop.questionId + "dropdown",
            type: "Dropdown",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: true,
            parentId: prop.parentId,
            data: this.dropdownData[prop.questionId],
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
          }
      }
    }
    this.amcRQuestionForm = new FormGroup(formDataObj);
  }

  /**
   * Name: createQuestionForm
   * purpose: To create question form
   */
  createEWQuestionForm(data: any) {
    this.submitted = false;
    const formDataObj = {};
    let questionIdAdded = [];
    for (const prop of data) {
      let response = '';
      let remark = '';
      this.ewAutofilledResponse.forEach((element) => {
        if(element.questionDesc == prop.questionDesc) {
          response = element.questionResponse;
          remark = element.remarks;
        }
      })
      if (!prop.length) {
        this.showField = true;
        if(prop.questionDesc == 'In process' || prop.questionDesc == 'Loss'
        || prop.questionDesc == 'Deal Closed') {
          this.showField = false;
        }
        let questionExist;
        if (prop.radioButtonType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "radio"] = new FormControl(response);
          this.ewQuestionInfo.push({
            label: prop.questionId + "radio",
            type: "RadioButton",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dropdownType == "Yes") {
        questionExist = questionIdAdded.filter(
          (group) => group == prop.questionId
        );
        formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
        this.ewQuestionInfo.push({
          label: prop.questionId + "dropdown",
          type: "Dropdown",
          desc: prop.questionDesc,
          id: prop.questionSequence,
          questionId: prop.questionId,
          showDesc: questionExist.length ? false : true,
          subQuestion: true,
          parentId: prop.parentId,
          data: this.dropdownData[prop.questionId],
          showField: this.showField
        });
        questionIdAdded.push(prop.questionId);
        }

        if (prop.remarksType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "text"] = new FormControl(remark);
          this.ewQuestionInfo.push({
            label: prop.questionId + "text",
            type: "Text",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dateType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "date"] = new FormControl(response);
          this.ewQuestionInfo.push({
            label: prop.questionId + "date",
            type: "Date",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.questionId == "37") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
          this.ewQuestionInfo.push({
            label: prop.questionId + "dropdown",
            type: "Dropdown",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: true,
            parentId: prop.parentId,
            data: this.dropdownData[prop.questionId],
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }
      }
    }
    this.ewQuestionForm = new FormGroup(formDataObj);
  }

  /**
   * Name: createQuestionForm
   * purpose: To create question form
   */
  createIRQuestionForm(data: any) {
    this.submitted = false;
    const formDataObj = {};
    let questionIdAdded = [];
    for (const prop of data) {
      let response = '';
      let remark = '';
      this.irAutofilledResponse.forEach((element) => {
        if(element.questionDesc == prop.questionDesc) {
          response = element.questionResponse;
          remark = element.remarks;
        }
      })
      if (!prop.length) {
        this.showField = true;
        if(prop.questionDesc == 'In process' || prop.questionDesc == 'Loss'
        || prop.questionDesc == 'Deal Closed') {
          this.showField = false;
        }
        let questionExist;
        if (prop.radioButtonType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "radio"] = new FormControl(response);
          this.irQuestionInfo.push({
            label: prop.questionId + "radio",
            type: "RadioButton",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dropdownType == "Yes") {
        questionExist = questionIdAdded.filter(
          (group) => group == prop.questionId
        );
        formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
        this.irQuestionInfo.push({
          label: prop.questionId + "dropdown",
          type: "Dropdown",
          desc: prop.questionDesc,
          id: prop.questionSequence,
          questionId: prop.questionId,
          showDesc: questionExist.length ? false : true,
          subQuestion: true,
          parentId: prop.parentId,
          data: this.dropdownData[prop.questionId],
          showField: this.showField
        });
        questionIdAdded.push(prop.questionId);
        }

        if (prop.remarksType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "text"] = new FormControl(remark);
          this.irQuestionInfo.push({
            label: prop.questionId + "text",
            type: "Text",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.dateType == "Yes") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "date"] = new FormControl(response);
          this.irQuestionInfo.push({
            label: prop.questionId + "date",
            type: "Date",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: false,
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
        }

        if (prop.questionId == "37") {
          questionExist = questionIdAdded.filter(
            (group) => group == prop.questionId
          );
          formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
          this.irQuestionInfo.push({
            label: prop.questionId + "dropdown",
            type: "Dropdown",
            desc: prop.questionDesc,
            id: prop.questionSequence,
            questionId: prop.questionId,
            showDesc: questionExist.length ? false : true,
            subQuestion: true,
            parentId: prop.parentId,
            data: this.dropdownData[prop.questionId],
            showField: this.showField
          });
          questionIdAdded.push(prop.questionId);
          }
      }
    }
    this.irQuestionForm = new FormGroup(formDataObj);
  }

  checkQuestionValidation(): boolean {
    let valid = true;
    if (this.AMCQuestionForm !== undefined) {
      this.amcradioFlag = false;
      this.amctextFlag = false;
      this.amcdropdownFlag = false;
      if(this.userRolesId == "1") {
        if(this.AMCQuestionForm.value["1radio"] == "") {
          valid = false;
          this.amcradioFlag = true;
        } else if(this.AMCQuestionForm.value["1radio"] == "Yes") {
          if(this.AMCQuestionForm.value["2dropdown"] == "") {
            this.amcdropdownFlag = true;
            valid = false;
          }
          if(this.AMCQuestionForm.value["3text"] == "") {
            this.amctextFlag = true;
            valid = false;
          }
          if(this.AMCQuestionForm.value["4radio"] == ""){
            this.amcradioFlag = true;
          } else if( this.AMCQuestionForm.value["4radio"] == "Yes") {
            if(this.AMCQuestionForm.value["4text"] == ""){
              this.amctextFlag = true;
              valid = false;
            }
          } else {
            this.amctextFlag = false;
          }
        }
      } else if(this.userRolesId == "2") {
        if (this.AMCQuestionForm.value["6dropdown"] == "" || this.AMCQuestionForm.value["7dropdown"] == ""
        || this.AMCQuestionForm.value["35dropdown"] == "" || this.AMCQuestionForm.value["11dropdown"] == ""
        || this.AMCQuestionForm.value["12dropdown"] == "" || this.AMCQuestionForm.value["14-1dropdown"] == "") {
          this.amcdropdownFlag = true;
          valid = false;
        }
        if(this.AMCQuestionForm.value["14-2dropdown"] == "") {
          this.amcdropdownFlag = true;
          valid = false;
        } else if(this.AMCQuestionForm.value["14-2dropdown"] == "In progress") {
          if(this.AMCQuestionForm.value["14-2-1dropdown"] == "") {
            this.amcdropdownFlag = true;
            valid = false;
          }
        } else if(this.AMCQuestionForm.value["14-2dropdown"] == "Loss") {
          if(this.AMCQuestionForm.value["14-2-2text"] == "") {
            this.amctextFlag = true;
            valid = false;
          }
        } else if(this.AMCQuestionForm.value["14-2dropdown"] == "Deal Closed") {
          if(this.AMCQuestionForm.value["14-2-3text"] == "") {
            this.amctextFlag = true;
            valid = false;
          }
        }
        if (this.AMCQuestionForm.value["8text"] == "") {
          this.amctextFlag = true;
          valid = false;
        }
        if (this.AMCQuestionForm.value["9radio"] == "") {
          this.amcradioFlag = true;
          valid = false;
        } else if (this.AMCQuestionForm.value["9radio"] == "Yes") {
          if(this.AMCQuestionForm.value["9text"] == "") {
            this.amctextFlag = true;
            valid = false;
          }
        } else {
          this.amctextFlag = false;
        }
        if (this.AMCQuestionForm.value["10date"] == "") {
          this.amcdateFlag = true;
          valid = false;
        }
      }
    }
    if (this.amcRQuestionForm !== undefined) {
      this.amcReradioFlag = false;
      this.amcRetextFlag = false;
      this.amcRedropdownFlag = false;
      if(this.userRolesId == "1") {
        if(this.amcRQuestionForm.value["1radio"] == "") {
          valid = false;
          this.amcReradioFlag = true;
        } else if(this.amcRQuestionForm.value["1radio"] == "Yes") {
          if(this.amcRQuestionForm.value["2dropdown"] == "") {
            this.amcRedropdownFlag = true;
            valid = false;
          }
          if(this.amcRQuestionForm.value["3text"] == "") {
            this.amcRetextFlag = true;
            valid = false;
          }
          if(this.amcRQuestionForm.value["4radio"] == ""){
            this.amcReradioFlag = true;
          } else if( this.amcRQuestionForm.value["4radio"] == "Yes") {
            if(this.amcRQuestionForm.value["4text"] == ""){
              this.amcRetextFlag = true;
              valid = false;
            }
          } else {
            this.amcRetextFlag = false;
          }
        }
      } else if(this.userRolesId == "2") {
        if (this.amcRQuestionForm.value["6dropdown"] == "" || this.amcRQuestionForm.value["7dropdown"] == ""
        || this.amcRQuestionForm.value["35dropdown"] == "" || this.amcRQuestionForm.value["11dropdown"] == ""
        || this.amcRQuestionForm.value["12dropdown"] == "") {
          this.amcRedropdownFlag = true;
          valid = false;
        }
        if(this.amcRQuestionForm.value["14-1dropdown"] == "") {
          this.amcRedropdownFlag = true;
          valid = false;
        }
        if(this.amcRQuestionForm.value["14-2dropdown"] == "") {
          this.amcRedropdownFlag = true;
          valid = false;
        } else if(this.amcRQuestionForm.value["14-2dropdown"] == "In progress") {
          if(this.amcRQuestionForm.value["14-2-1dropdown"] == "") {
            this.amcRedropdownFlag = true;
            valid = false;
          }
        } else if(this.amcRQuestionForm.value["14-2dropdown"] == "Loss") {
          if(this.amcRQuestionForm.value["14-2-2text"] == "") {
            this.amcRetextFlag = true;
            valid = false;
          }
        } else if(this.amcRQuestionForm.value["14-2dropdown"] == "Deal Closed") {
          if(this.amcRQuestionForm.value["14-2-3text"] == "") {
            this.amcRetextFlag = true;
            valid = false;
          }
        }
        if (this.amcRQuestionForm.value["8text"] == "") {
          this.amcRetextFlag = true;
          valid = false;
        }
        if (this.amcRQuestionForm.value["9radio"] == "") {
          this.amcReradioFlag = true;
          valid = false;
        } else if (this.amcRQuestionForm.value["9radio"] == "Yes") {
          if(this.amcRQuestionForm.value["9text"] == "") {
            this.amcRetextFlag = true;
            valid = false;
          }
        } else {
          this.amcRetextFlag = false;
        }
        if (this.amcRQuestionForm.value["10date"] == "") {
          this.amcRedateFlag = true;
          valid = false;
        }
      }
    }
    if (this.ewQuestionForm !== undefined) {
      this.ewradioFlag = false;
      this.ewtextFlag = false;
      this.ewdropdownFlag = false;
      if(this.userRolesId == "1") {
        if(this.ewQuestionForm.value["15radio"] == "") {
          valid = false;
          this.ewradioFlag = true;
        } else if(this.ewQuestionForm.value["15radio"] == "Yes") {
          if(this.ewQuestionForm.value["17text"] == "") {
            this.ewtextFlag = true;
            valid = false;
          }
          if(this.ewQuestionForm.value["18radio"] == ""){
            this.ewradioFlag = true;
            valid = false;
          } else if(this.ewQuestionForm.value["18radio"] == "Yes") {
            if(this.ewQuestionForm.value["18text"] == ""){
              this.ewtextFlag = true;
              valid = false;
            }
          } else {
            this.ewtextFlag = false;
          }
        }
      } else if(this.userRolesId == "2") {
        if(this.ewQuestionForm.value["23radio"] == "") {
          this.ewradioFlag = true;
          valid = false;
        } else if(this.ewQuestionForm.value["23radio"] == "Yes") {
          if(this.ewQuestionForm.value["23text"] == "") {
            this.ewtextFlag = true;
            valid = false;
          }
        } else {
          this.ewtextFlag = false;
        }
        if (this.ewQuestionForm.value["24date"] == "") {
          this.ewdateFlag = true;
          valid = false;
        }
        if (this.ewQuestionForm.value["26dropdown"] == "" || this.ewQuestionForm.value["28dropdown"] == ""
        || this.ewQuestionForm.value["37-1dropdown"] == "") {
          this.ewdropdownFlag = true;
          valid = false;
        }
        if (this.ewQuestionForm.value["22text"] == "") {
          this.ewtextFlag = true;
          valid = false;
        }
        if(this.ewQuestionForm.value["37-2dropdown"] == "") {
          this.ewdropdownFlag = true;
          valid = false;
        } else if(this.ewQuestionForm.value["37-2dropdown"] == "In progress") {
          if(this.ewQuestionForm.value["37-2-1dropdown"] == "") {
            this.ewdropdownFlag = true;
            valid = false;
          }
        } else if(this.ewQuestionForm.value["37-2dropdown"] == "Loss") {
          if(this.ewQuestionForm.value["37-2-2text"] == "") {
            this.ewtextFlag = true;
            valid = false;
          }
        } else if(this.ewQuestionForm.value["37-2dropdown"] == "Deal Closed") {
          if(this.ewQuestionForm.value["37-2-3text"] == "") {
            this.ewtextFlag = true;
            valid = false;
          }
        }
      }
    }
    if (this.irQuestionForm !== undefined) {
      this.irradioFlag = false;
      this.irtextFlag = false;
      this.irdropdownFlag = false;
      if(this.userRolesId == "1") {
        if(this.irQuestionForm.value["29radio"] == "") {
          valid = false;
          this.irradioFlag = true;
        } else if(this.irQuestionForm.value["29radio"] == "Yes") {
          if(this.irQuestionForm.value["30radio"] == ""){
            this.irradioFlag = true;
            valid = false;
          } else if(this.irQuestionForm.value["30radio"] == "Yes") {
            if(this.irQuestionForm.value["30text"] == ""){
              this.irtextFlag = true;
              valid = false;
            }
          } else {
            this.irtextFlag = false;
          }
        }
      } else if(this.userRolesId == "2") {
        if(this.irQuestionForm.value["31radio"] == "") {
          this.irradioFlag = true;
          valid = false;
        } else if(this.irQuestionForm.value["31radio"] == "Yes") {
          if(this.irQuestionForm.value["31text"] == "") {
            this.irtextFlag = true;
            valid = false;
          }
        } else {
          this.irtextFlag = false;
        }
        if (this.irQuestionForm.value["32date"] == "") {
          this.irdateFlag = true;
          valid = false;
        }
        if (this.irQuestionForm.value["33dropdown"] == "" || this.irQuestionForm.value["36-1dropdown"] == "") {
          this.irdropdownFlag = true;
          valid = false;
        }
        if(this.AMCQuestionForm.value["36-2dropdown"] == "") {
          this.amcdropdownFlag = true;
          valid = false;
        } else if(this.AMCQuestionForm.value["36-2dropdown"] == "In progress") {
          if(this.AMCQuestionForm.value["36-2-1dropdown"] == "") {
            this.amcdropdownFlag = true;
            valid = false;
          }
        } else if(this.AMCQuestionForm.value["36-2dropdown"] == "Loss") {
          if(this.AMCQuestionForm.value["36-2-2text"] == "") {
            this.amctextFlag = true;
            valid = false;
          }
        } else if(this.AMCQuestionForm.value["36-2dropdown"] == "Deal Closed") {
          if(this.AMCQuestionForm.value["36-2-3text"] == "") {
            this.amctextFlag = true;
            valid = false;
          }
        }
      }
    }
    this.formSubmitted = valid;
    return valid;
  }

  getAmcFeedbackValue(questions: any, questionValue: any) {
    let idFeedback = "";
    let formValue = questions.value;
    questionValue.forEach((element, index) => {
      let feedback = "";
      if ( element.radioButtonType == "Yes" && formValue[element.questionId + "radio"]) {
        feedback = feedback + "#" + formValue[element.questionId + "radio"];
      } else if(element.radioButtonType == "Yes"){
        feedback = feedback + "#"+ "";
      }
      if ( element.dropdownType == "Yes" && formValue[element.questionId + "dropdown"]) {
        feedback = feedback + "#" + formValue[element.questionId + "dropdown"];
      }  else if(element.dropdownType == "Yes") {
        feedback = feedback + "#"+ "";
      }
      if ( element.dateType == "Yes" && formValue[element.questionId + "date"]) {
        feedback = feedback + "#" + formValue[element.questionId + "date"];
      }  else if(element.dateType == "Yes") {
        feedback = feedback + "#"+ "";
      }
      if ( element.remarksType == "Yes" && formValue[element.questionId + "text"]) {
        if(element.questionId == "3" || element.questionId == "8" || element.questionId == "13"
        || element.questionId == "17" || element.questionId == "22" || element.questionId == "28"
        || element.questionId == "34") {
          feedback = feedback + "#" + formValue[element.questionId + "text"] + "#";
        } else if(element.questionId != "14-2-2" && element.questionId != "14-2-3" && element.questionId != "36-2-2"
        && element.questionId != "36-2-3" && element.questionId != "37-2-2" && element.questionId != "37-2-3") {
          feedback = feedback + "#" + formValue[element.questionId + "text"];
        }
      } else if(element.questionId != "14-2-2" && element.questionId != "14-2-3" && element.questionId != "36-2-2"
      && element.questionId != "36-2-3" && element.questionId != "37-2-2" && element.questionId != "37-2-3") {
        feedback = feedback + "#"+ "";
      }
      if ( element.remarksType == "Yes" && formValue[element.questionId + "text"]) {
        if(element.questionId == "14-2-2" || element.questionId == "14-2-3" || element.questionId == "36-2-2"
        || element.questionId == "36-2-3" || element.questionId == "37-2-2" || element.questionId == "37-2-3") {
          feedback = feedback + "#" + formValue[element.questionId + "text"] + "#";
        }
      } else if(element.remarksType == "Yes") {
        if(element.questionId == "14-2-2" || element.questionId == "14-2-3" || element.questionId == "36-2-2"
        || element.questionId == "36-2-3" || element.questionId == "37-2-2" || element.questionId == "37-2-3") {
          feedback = feedback + "#" + formValue[element.questionId + "text"] + "#";
        }
      }
      feedback = feedback != "" ? element.questionId + feedback : feedback;
      if (feedback != "") {
        if (index == 0) {
          idFeedback = feedback;
        } else {
          idFeedback = idFeedback == "" ? feedback : idFeedback + ";" + feedback;
        }
      }
    });
    return idFeedback;
  }


  saveResponseData() {
    this.formSubmitted = true;
    if (this.checkQuestionValidation()) {
      let amcFeedback = "";
      let amcReFeedback = "";
      let ewFeedback = "";
      let irFeedback = "";
      if( this.amcNewOffering == "YES") {
        amcFeedback = this.getAmcFeedbackValue(this.AMCQuestionForm, this.amcQuestions);
      }
      if( this.amcRenewal == "YES") {
        amcReFeedback = this.getAmcFeedbackValue(this.amcRQuestionForm, this.amcReQuestions);
      }
      if( this.extendedWarranty == "YES") {
        ewFeedback = this.getAmcFeedbackValue(this.ewQuestionForm, this.ewQuestions);
      }
      if( this.insuranceRenewal == "YES") {
        irFeedback = this.getAmcFeedbackValue(this.irQuestionForm, this.irQuestions);
      }
      this.getCustomerName(this.cusType);
      let request = {
        userId: this.userId || "",
        customerId: this.customerData.customerId || "",
        vin: this.selectedVin,
        workshopCode: this.selectedWorkShop || "",
        amcFeedback: amcFeedback,
        amcReFeedback: amcReFeedback,
        ewFeedback: ewFeedback,
        irFeedback: irFeedback,
        amcNewOffering: this.amcNewOffering,
        amcRenewal: this.amcRenewal,
        insuranceRenewal: this.insuranceRenewal,
        extendedWarranty: this.extendedWarranty,
        customerType: this.ownerSelected ? "C" : this.fleetSelected ? "F" : "D",
        phoneNo: this.selectedNumber?this.selectedNumber:'',
        customerName:this.custNameForSave?this.custNameForSave:''
        // this.custNameForSave?this.custNameForSave:this.cus360["CUSTOMER_INFO"].custName
      };
      this.saveResponse(request);

      //Test
    }
  }

  saveResponse(requestData: any): void {
    //this.commonService.prsCustomerResponse = '';
    this.commonService.amcSaveVinFeedback(requestData).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.toastr.info(res["message"], "Success");
          //this.commonService.prsCustomerResponse = requestData;
          this.clear();
          this.formSubmitted = false;
          if(!((this.cus360.VECHILE_INFO.length - 1) > 0)) {
            this.router.navigate(["soft-calling"]);
          } else {
            this.chassis = this.cus360["VECHILE_INFO"].filter((vehicle) => vehicle.chassisNo != this.selectedVehicle)[0].chassisNo;
            this.getCustomer360();
          }
        } else {
          this.formSubmitted = false;
          this.spinner = false;
          this.toastr.error(res["message"], "Error");
        }
      },
      (error) => {
        this.formSubmitted = false;
        this.toastr.error(error, "Error");
        this.spinner = false;
      }
    );
  }

  clear() {
    this.AMCQuestionForm = undefined;
    this.amcRQuestionForm = undefined;
    this.ewQuestionForm = undefined;
    this.irQuestionForm = undefined;
    this.amcQuestionInfo = [];
    this.amcRQuestionInfo = [];
    this.ewQuestionInfo = [];
    this.irQuestionInfo = [];
    this.amcInProgress = '';
    this.amcReInProgress = '';
    this.irInProgress = '';
    this.ewInProgress = '';
    this.createAmcQuestionForm(this.amcQuestions);
    this.createAMCRQuestionForm(this.amcReQuestions);
    this.createEWQuestionForm(this.ewQuestions);
    this.createIRQuestionForm(this.irQuestions);
    this.formSubmitted = false;
  }

  // amcSelectStatus(event : any) {
  //   this.amcInProgress = '';
  //   this.amcSelectedQuestionCurrentStatus = [];
  //   this.amcSelectedQuestionStatus = [];
  //   this.amcQuestionInfo.forEach((element) => {
  //     if(element.desc == event) {
  //       this.amcSelectedQuestionStatus = element;
  //     }
  //   });
  // }

  amcSelectCurrentStatus(event : any) {
    this.amcSelectedQuestionCurrentStatus = [];
    //this.amcInProgress = event;
    // this.amcQuestionInfo.forEach((element) => {
    //   if(element.desc == event) {
    //     //this.amcSelectedQuestionCurrentStatus = element;
    //     // questionExist = questionIdAdded.filter(
    //     //   (group) => group == prop.questionId
    //     // );
    //     //formDataObj[prop.questionId + "dropdown"] = new FormControl(response);
    //     // this.amcSelectedQuestionCurrentStatus.push({
    //     //   label: element.questionId + "dropdown",
    //     //   type: "Dropdown",
    //     //   desc: element.questionDesc,
    //     //   id: element.questionSequence,
    //     //   questionId: element.questionId,
    //     //   showDesc: true,
    //     //   subQuestion: true,
    //     //   parentId: element.parentId,
    //     //   data: this.dropdownData[element.questionId],
    //     //   showField: this.showField
    //     // });
    //   }
    // });
  }

  // amcReSelectStatus(event : any) {
  //   this.amcReInProgress = '';
  //   this.amcReSelectedQuestionCurrentStatus = [];
  //   this.amcReSelectedQuestionStatus = [];
  //   this.amcRQuestionInfo.forEach((element) => {
  //     if(element.desc == event) {
  //       this.amcReSelectedQuestionStatus = element;
  //     }
  //   });
  // }

  amcReSelectCurrentStatus(event : any) {
    this.amcReSelectedQuestionCurrentStatus = [];
    //this.amcReInProgress = event;
    this.amcRQuestionInfo.forEach((element) => {
      if(element.desc == event) {
        this.amcReSelectedQuestionCurrentStatus = element;
      }
    });
  }

  // irSelectStatus(event : any) {
  //   this.irInProgress = '';
  //   this.irSelectedQuestionCurrentStatus = [];
  //   this.irSelectedQuestionStatus = [];
  //   this.irQuestionInfo.forEach((element) => {
  //     if(element.desc == event) {
  //       this.irSelectedQuestionStatus = element;
  //     }
  //   });
  // }

  irSelectCurrentStatus(event : any) {
    this.irSelectedQuestionCurrentStatus = [];
    //this.irInProgress = event;
    this.irQuestionInfo.forEach((element) => {
      if(element.desc == event) {
        this.irSelectedQuestionCurrentStatus = element;
      }
    });
  }

  // ewSelectStatus(event : any) {
  //   this.ewInProgress = '';
  //   this.ewSelectedQuestionCurrentStatus = [];
  //   this.ewSelectedQuestionStatus = [];
  //   this.ewQuestionInfo.forEach((element) => {
  //     if(element.desc == event) {
  //       this.ewSelectedQuestionStatus = element;
  //     }
  //   });
  // }
  
  ewSelectCurrentStatus(event: any) {
    this.ewSelectedQuestionCurrentStatus = [];
    //this.ewInProgress = event;
    this.ewQuestionInfo.forEach((element) => {
      if(element.desc == event) {
        this.ewSelectedQuestionCurrentStatus = element;
      }
    });
  }



  activeTabLabel: string = 'Owner'; 
  activeIndex:number = 0
  userInfo: any;


  selectedContactNumbers = {
    'Owner': null,
    'Fleet Manager': null,
    'Driver': null
  };

  onTabChange(event: MatTabChangeEvent) {
    this.activeTabLabel = event.tab.textLabel;
    this.activeIndex = event.index;
    this.updateActiveContactNo();
  }

 

  private updateActiveContactNo() {
    let contactList;
    
    if (this.activeIndex === 0) {
      contactList = this.contactInfoOwner;
    } else if (this.activeIndex === 1) {
      contactList = this.contactInfoFleet;
    } else if (this.activeIndex === 2) {
      contactList = this.contactInfoDriver;
    }
    
    console.log(this.activeIndex);
    console.log(contactList);
    if (contactList && contactList.length > 0) {
      this.selectedContactNumbers[this.activeTabLabel] = this.selectedContactNumbers[this.activeTabLabel] || contactList[0].contactNo;
    }
    
  }
  
  onRadioChange(contactNo: string, tabLabel: string) {
    this.selectedContactNumbers[tabLabel] = contactNo;
   
    
  }


  private callingToUser(){
    let customerPhone = this.selectedContactNumbers[this.activeTabLabel];
    if(customerPhone){
      this.makeCall(customerPhone)
    }else{
      this.spinner = false;
      this.toastr.error("Customer Phone number can't be Empty while placing the call")
    }
  }

  
  private makeCall(customerPhone:string) {
    const callParams = new CallParams(this.userInfo.contactNo, customerPhone);
    this.spinner = true
    this.commonService.createCallConnection_API(callParams).subscribe({
      next: (response) => {
        if(response.responseData.Uri) {
          localStorage.setItem("exotel_URI",response.responseData.Uri)
        } else{
          localStorage.setItem("exotel_URI",'')
        }
       
        if (response.responseCode==0) {
          this.toastr.success("Call is in progress")
          
        }else{
          this.toastr.error(response.responseData)
        }
        
      },
      error:(error)=>{
        this.spinner = false
        this.toastr.error("Something went wrong");
        
      },
      complete:()=>{
        this.spinner = false
      }
    });
  }

 
  openConfirmation() {
    if (localStorage.getItem('countryCode')=='IND91') {
      this.dialogService.openConfirmDialog().subscribe(result => {
        if (result) {
          console.log(result);
          this.callUser();    
        } else {
          console.log(result);
        }
      });
    }else{
      this.callUser();
    }
   
  }

  
}



